import { useSelector } from "react-redux";
import PackageFlowModel from "../model/PackageFlowModel";

const HandleModel = () => {
  
  const newPackageModel = useSelector(
    (state: { modal: { newPackageModel: boolean } }) => state.modal.newPackageModel
  );

  return (
    <>
      {newPackageModel && <PackageFlowModel />}
    </>
  );
};

export default HandleModel;
